"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoSourceSchema = exports.VideoSourceDrmSchema = exports.VideoSourceWidevineSchema = exports.VideoSourcePlayreadySchema = exports.VideoSourceFairplaySchema = exports.VideoMimetypeSchema = void 0;
var zod_1 = require("zod");
var video_source_1 = require("../video-source");
exports.VideoMimetypeSchema = zod_1.z.nativeEnum(video_source_1.VideoMimetype);
exports.VideoSourceFairplaySchema = zod_1.z.object({
    licenseUrl: zod_1.z.string(),
    certificateUrl: zod_1.z.string(),
});
exports.VideoSourcePlayreadySchema = zod_1.z.object({
    licenseUrl: zod_1.z.string(),
});
exports.VideoSourceWidevineSchema = zod_1.z.object({
    licenseUrl: zod_1.z.string(),
    certificateUrl: zod_1.z.string(),
});
exports.VideoSourceDrmSchema = zod_1.z
    .object((_a = {},
    _a["fairplay" /* VideoSourceDrmKey.FAIRPLAY */] = exports.VideoSourceFairplaySchema,
    _a["playready" /* VideoSourceDrmKey.PLAYREADY */] = exports.VideoSourcePlayreadySchema,
    _a["widevine" /* VideoSourceDrmKey.WIDEVINE */] = exports.VideoSourceWidevineSchema,
    _a["primetime" /* VideoSourceDrmKey.PRIMETIME */] = zod_1.z.undefined(),
    _a))
    .partial();
exports.VideoSourceSchema = zod_1.z.object({
    mimetype: exports.VideoMimetypeSchema,
    url: zod_1.z.string(),
    error: zod_1.z.object({ message: zod_1.z.string() }).optional(),
    width: zod_1.z.number().optional(),
    height: zod_1.z.number().optional(),
    bitrate: zod_1.z.number().optional(),
    startOffset: zod_1.z.number().optional(),
    drm: exports.VideoSourceDrmSchema.optional(),
    metadata: zod_1.z
        .object({
        vasLifecycleId: zod_1.z.string(),
        geolocation: zod_1.z.string(),
        countrycode_platform: zod_1.z.string(),
        contentDeliveryNetwork: zod_1.z.string(),
        validUntil: zod_1.z.number(),
    })
        .optional(),
});
//# sourceMappingURL=video-source.js.map